// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__16ZH2","balanceDisclaimer":"posDashboard_balanceDisclaimer__3Ch37"};